var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-4"},[_c('v-col',{staticClass:"py-1",attrs:{"cols":"12"}},[_c('SectionHeader',{attrs:{"title":"Condomínio"}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.condObj.name))]),_c('v-card-subtitle',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }